module.exports = __webpack_public_path__ + "static/media/6.99a0a274.png";